<template>
  <ControlWrapper
    v-bind="controlWrapper"
    :styles="styles"
    :is-focused="isFocused"
    :applied-options="appliedOptions"
    :error="control.errors"
  >
  </ControlWrapper>
</template>

<script lang="ts">
  import { defineComponent, computed, inject, watch, ref } from 'vue';
  import type { ControlElement, JsonFormsSubStates } from '@jsonforms/core';

  import { rendererProps, useJsonFormsControl, RendererProps } from '@jsonforms/vue';
  import ControlWrapper from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import dayjs, { UnitType } from 'dayjs';

  interface HiddenRecentIncidentOption {
    range: string;
    unit: UnitType;
  }

  export default defineComponent({
    components: {
      ControlWrapper,
    },
    props: {
      ...rendererProps<ControlElement>(),
    },
    setup(props: RendererProps<ControlElement>) {
      const control = useWidgetControl(useJsonFormsControl(props));
      const jsonforms = inject<JsonFormsSubStates>('jsonforms');

      const controlOptions = ref(control.control.value.schema as unknown as HiddenRecentIncidentOption);

      const collisionDate = computed(() => jsonforms?.core?.data?.date as undefined | string);
      watch(
        collisionDate,
        () => {
          const now = dayjs();
          const date = dayjs(collisionDate.value);
          const diff = now.diff(date, controlOptions.value.unit);
          control.onChange(diff <= Number(controlOptions.value.range));
        },
        { immediate: true }
      );
      return {
        ...control,
      };
    },
  });
</script>

<style scoped></style>
